import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: true,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['leap', 'pragmatic', 'evolution', 'relax', 'blueprint'],
        'live-casino': ['pragmatic', 'evolution', 'ezugi'],
        virtuals: ['leap', 'pragmatic'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: false,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'], // TODO: Please verify
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: false,
    decimalLength: 2,
    depositLimitType: 'calendarType',
    depositLimitCalculationTypeConfigurable: true,
    depositRestriction: true,
    deceased: false,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text:
            'Gentleman Jim Bookmakers is a trading name of Lovell Brothers Limited, a company incorporated in England and Wales with company number 13760050. Registered office: 2 Alexandra Gate Fford Pengam, Cardiff, CF24 2SA. Lovell Brothers Limited is licensed and regulated in Great Britain by the Gambling Commission under account number {{licenceNumber}} This site uses cookies, for more information please see our cookie policy.',
        licence_number: '60213',
        licence_url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/60213',
        cookies_url: 'https://gentlemanjim.bet/?account=static&static=cookie-policy',
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: 'GTM-MJ6V5WT7',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'Gentleman Jim', // TODO: Please verify

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    reportsV2: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '1',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'ding',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: '#TOBEADDED', // TODO: Please update
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: false,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: false,

    /* U */
    useExtraPlacesForEvents: false,
    usePaymentFormForUniverse: {
        type: 'multi-deposit',
        apiKey: 'T1QtMzM1MDUyOkItcDEtMC02NjIyNzc5MS0wLTMwMmQwMjE0N2JlZjYwNzUyMzBlYjEwN2IyZmYwZTdlYWU2OGIwOTQ1OTllYWVlOTAyMTUwMDg5ZGIwZTRlZTBjMGIxMTJlY2RmZjU1YWE5NjZlNDk2NDQxYTQxODI=',
        environment: 'LIVE',
        cardAccounts: {
            GBP: '1002971612',
            EUR: '',
        },
        openBanking: null,
    },
    userTitleOptional: false,

    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        Accounts: 'Accounts-GentlemanJim/Overview',
        AccountBalances: 'AccountBalances-GentlemanJim/AccountBalances',
        BackofficeReports: 'BackOfficeReports-GentlemanJim/DB-Casino',
        CasinoDashboard: 'CasinoDashboard-GentlemanJim/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-GentlemanJim/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-GentlemanJim/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-GentlemanJim/DailyKPI',
        RacecourseDashboard: 'Racecourse-GentlemanJim/RacecourseMediaGroupDashboard',
        TransactionsDashboard: 'TransactionsDashboard-GentlemanJim/TransactionsMainDashboard',
        SRGDashboard: 'SRGDashboard-GentlemanJim/DBUseofGamblingManagementTools',
        RollingNetDeposits: 'RollingNetDeposits-GentlemanJim/RollingNetDeposits',
        LiveChat: 'LiveChat-GentlemanJim/LiveChatDashboard',
        TargetingAttributes: 'TargetingAttributes-GentlemanJim/ValueTiering',
        BonusEngine: 'BonusEngine-GentlemanJim/CampaignLevel',
        PromoPrediction: 'PromoPrediction-GentlemanJim/SinglePromoAnalysis',
    },
};
